<template>
    <div class="space-y-6 mt-6">
        <!-- Header -->
        <div
            class="flex flex-col lg:flex-row lg:items-center lg:justify-between"
        >
            <div>
                <h1 class="text-3xl font-bold text-theme-primary">
                    ¡Hola, {{ user.name }} 👋
                </h1>

                <p class="mt-2 text-theme-base">
                    Bienvenido nuevamente. Aquí tienes un resumen de tu
                    catálogo.
                </p>
            </div>
        </div>

        <!-- Mientras le falten cosas al catálogo, la lista ocupa el lugar
             de la card del plan para no saturar el inicio. -->
        <catalog-pending-tasks-card
            v-if="showPendingTasks"
            :tasks="pendingTasks"
            :trial-text="trialText"
            @see-plans="goToPlans('/app/plan/change')"
        />
        <plan-upgrade-card
            v-else-if="showPlanCard"
            :subscription="subscription"
            :products-unlocked="productsUnlocked"
            @see-plans="goToPlans"
        />

        <div
            class="grid grid-cols-1 gap-6"
            :class="canViewCatalogPreview ? 'lg:grid-cols-5' : ''"
        >
            <app-tools
                class="order-last lg:order-first"
                :class="canViewCatalogPreview ? 'lg:col-span-3' : ''"
            />
            <div class="order-first lg:order-last lg:col-span-2">
                <catalog-preview-card
                    v-if="canViewCatalogPreview"
                    collapsible
                    @loaded="onCatalogLoaded"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

import { OperationsModes } from "@/common/fields/operations-modes";
import { planNameFromCode } from "@/common/fields/plan-features";
import { catalogTasks } from "@/common/lib/catalog-pending-tasks";
import { daysUntil } from "@/common/lib/plan-periods";

import CatalogPreviewCard from "@/components/editor/CatalogPreviewCard.vue";
import CatalogPendingTasksCard from "@/components/onboarding/CatalogPendingTasksCard.vue";
import AppTools from "@/components/utils/AppTools.vue";
import PlanUpgradeCard from "@/components/utils/PlanUpgradeCard.vue";

export default {
    name: "AppIndex",
    components: {
        AppTools,
        CatalogPendingTasksCard,
        CatalogPreviewCard,
        PlanUpgradeCard
    },
    data() {
        return {
            catalog: null,
            catalogResolved: false
        };
    },
    computed: {
        ...mapState("auth", [
            "user",
            "tenantId",
            "featureFlags",
            "subscription"
        ]),
        productsUnlocked() {
            return !!this.featureFlags?.productsUnlocked;
        },
        canViewNotifications() {
            return (
                !!this.tenantId &&
                this.$ability.hasPermission("notification:List")
            );
        },
        canViewCatalogPreview() {
            return this.$ability.hasPermission("page:GetCatalog");
        },
        // Los datos salen de la vista previa del catálogo de esta página.
        pendingTasksEnabled() {
            return (
                this.$operationMode === OperationsModes.multiTenant &&
                this.canViewCatalogPreview
            );
        },
        pendingTasks() {
            return this.catalog ? catalogTasks(this.catalog) : [];
        },
        showPendingTasks() {
            return (
                this.pendingTasksEnabled &&
                this.pendingTasks.some((task) => !task.done)
            );
        },
        // Sin esperar al catálogo, la card del plan salía y se cambiaba
        // por la lista apenas cargaba.
        showPlanCard() {
            return !this.pendingTasksEnabled || this.catalogResolved;
        },
        trialText() {
            const subscription = this.subscription;
            if (!subscription || subscription.type !== "trial") return "";
            const planName = planNameFromCode(subscription.planCode);
            if (!subscription.currentPeriodEnd) {
                return `Estás en prueba de ${planName}.`;
            }
            const days = daysUntil(subscription.currentPeriodEnd);
            if (days === 0) return `Tu prueba de ${planName} termina hoy.`;
            return days === 1
                ? `Te queda 1 día de prueba de ${planName}.`
                : `Te quedan ${days} días de prueba de ${planName}.`;
        }
    },

    watch: {},
    async mounted() {
        if (this.canViewNotifications) {
            this.listNotificationsComponent(true);
        }
        this.reloadMerchantPermissions();
    },
    methods: {
        ...mapActions("notifications", ["listNotifications"]),
        ...mapActions("auth", ["reloadMerchantPermissions"]),
        onCatalogLoaded(catalog) {
            this.catalog = catalog;
            this.catalogResolved = true;
        },
        goToPlans(path) {
            this.$router.push(path);
        },

        async listNotificationsComponent(required = false) {
            try {
                await this.listNotifications({ required });
            } catch (error) {
                console.error(error);
            }
        }
    }
};
</script>
